import { render } from "./OrderPaymentCreatePage.vue?vue&type=template&id=dc1dbb98"
import script from "./OrderPaymentCreatePage.vue?vue&type=script&lang=js"
export * from "./OrderPaymentCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__